import type { FC } from 'react';

import { Error } from '@cuemath/leap';
import useSentryCaptureException from 'hooks/use-sentry-capture-exception';
import { memo } from 'react';
import React, { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';

const AllRoutesError: FC = () => {
  const error = useRouteError();
  const sentryCaptureException = useSentryCaptureException();

  useEffect(() => {
    sentryCaptureException(error as Error);
  }, [error, sentryCaptureException]);

  return <Error height="100vh" />;
};

export default memo(AllRoutesError);
